// @flow

import type { PropsSchema, BasicProps, JsEnv, EasyAction } from '../../type'
import RCropper from 'react-cropper'
import 'cropperjs/dist/cropper.css'

import * as React from 'react'
import computeData from '../hoc/computeData'
import { loading } from 'frame/ui/popup'
import { base64ToFile } from '../util/compressImg'

type Props = BasicProps & {
  style: { [string]: string },
  jsEnv: JsEnv,
  aspectRatio: number,
  maxWidth: number
};

@computeData({
  includeData: true,
  includeVisible: false,
  annotation: '//接收字段：img'
})
export default class Cropper extends React.PureComponent<
  Props,
  { fileSrc: string | { convertId: string } }
> {
  cropper: any;

  constructor (props: Props) {
    super(props)

    this.state = {
      fileSrc: ''
    }
  }
  static schema: PropsSchema = [
    {
      type: 'number',
      title: '裁剪比例',
      key: 'aspectRatio',
      defaultValue: '1'
    },
    {
      type: 'number',
      title: '图片最大宽度(0不限制宽度,高=宽/比例)',
      key: 'maxWidth',
      defaultValue: '100'
    },
    'separator',
    {
      type: 'style'
    },

    'separator',
    {
      type: 'event',
      title: '裁剪完成',
      event: 'cropDone',
      desc: '默认返回file对象,属性：src:base64，blob:Blob'
    }
  ];

  static actions: EasyAction[] = [
    {
      title: '加载图片',
      name: 'loadImg'
    },
    {
      title: '执行裁剪',
      name: 'doCrop'
    },
    {
      title: '旋转',
      name: 'rotate'
    }
  ];

  actionLoadImg = (data: void, dynamicData: { convertId: string }) => {
    this.setState({ fileSrc: dynamicData })
  };

  actionDoCrop = (data: void, dynamicData: { convertId: string }) => {
    const { callActions, maxWidth, aspectRatio } = this.props
    let options = {}
    if (maxWidth !== '0') {
      options.width = maxWidth
      options.height = maxWidth / aspectRatio
    }
    loading(
      new Promise((resolve, reject) => {
        let canvas = this.cropper.getCroppedCanvas(options)
        let base64Src = canvas.toDataURL('image/jpeg')
        let newBlob = base64ToFile(base64Src, 'temp.jpg')
        callActions('cropDone', { file: { src: base64Src, blob: newBlob } })
        resolve()
      })
    )
  };

  actionRotate = (data: void, dynamicData: { convertId: string }) => {
    this.cropper.rotate('90')
  };

  render () {
    let { style, jsEnv, aspectRatio } = this.props
    aspectRatio = Number(aspectRatio)
    const img = jsEnv.runCode('img')
    let { fileSrc } = this.state
    fileSrc = fileSrc || img
    return (
      <RCropper
        style={style}
        src={fileSrc}
        ref={cropper => (this.cropper = cropper)}
        // Cropper.js options
        viewMode={2}
        zoomable
        aspectRatio={aspectRatio}
        guides={false}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/basic/Cropper.js